/* eslint-disable import/no-extraneous-dependencies */
import axios from 'axios';
import Cookies from 'js-cookie';
import { isNaN } from 'lodash';
import api from '~/services/api';
import {
  // CONVERSION_API_META_PIXEL_ID,
  // CONVERSION_API_META_TOKEN,
  Connection,
} from '~/services/config';
import {
  getStorageTracking,
  updateStorageTracking,
} from '~/storage/StorageTracking';
// import { generateHashSHA256 } from './crypto';

// export async function ConversionApiMeta({
//   eventId,
//   eventName,
//   email,
//   phone,
//   externalId,
// }) {
//   try {
//     const hashEmail = await generateHashSHA256(email);
//     const hashPhone = await generateHashSHA256(phone);
//     // const hashUserId = await generateHashSHA256(userId);

//     const fbp = Cookies.get('_fbp');
//     const fbc = Cookies.get('_fbc');

//     const now = new Date();

//     // Obtém o timestamp Unix em milissegundos e divide por 1000 para converter para segundos
//     const unixTimestampSeconds = Math.floor(now.getTime() / 1000);

//     const data = [
//       {
//         event_name: eventName,
//         event_time: unixTimestampSeconds,
//         action_source: 'website',
//         event_source_url: window.location.href,
//         user_data: {
//           em: [
//             hashEmail, // email
//           ],
//           ph: [
//             hashPhone, // phone
//           ],
//           fbp,
//           fbc,
//           external_id: externalId,
//         },
//       },
//     ];

//     if (eventName === 'Subscribe') {
//       data[0].custom_data = {
//         value: 29.9, // valor da assinatura
//         currency: 'BRL', // moeda
//         subscription_plan: 'Premium', // plano de assinatura
//         subscription_period: 'Mensal',
//       };
//     }

//     if (eventId) {
//       data[0].event_id = eventId;
//     }

//     try {
//       await axios.get('https://api.ipify.org/?format=json').then(response => {
//         if (response.data && response.data.ip) {
//           data[0].user_data.client_ip_address = response.data.ip;
//           data[0].user_data.client_user_agent = window.navigator.userAgent;
//         }
//       });
//     } catch (err) {
//       console.log(err);
//     }

//     const result = await axios.post(
//       `https://graph.facebook.com/v20.0/${CONVERSION_API_META_PIXEL_ID}/events`,
//       {
//         data,
//         test_event_code: 'TEST15160',
//       },
//       {
//         params: {
//           access_token: CONVERSION_API_META_TOKEN,
//         },
//       }
//     );

//     // console.log('eventSucess', result);
//     return result;
//   } catch (err) {
//     console.log('Erro ao enviar evento do Pixel', err);
//   }
// }

export function isFbcExpired(fbc) {
  if (!fbc || !fbc.startsWith('fb.')) return true;

  const parts = fbc.split('.');
  if (parts.length < 4) return true; // precisa ter pelo menos 4 partes

  const timestampStr = parts[2];
  const timestamp = Number(timestampStr);

  if (isNaN(timestamp)) return true;

  const creationDate = new Date(timestamp);
  const now = new Date();
  const diffInDays =
    (now.getTime() - creationDate.getTime()) / (1000 * 60 * 60 * 24);

  return diffInDays > 90;
}

export async function getFbc(userregistrationtracking) {
  try {
    const cookieFbc = Cookies.get('_fbc');
    const storageTracking = getStorageTracking();

    if (userregistrationtracking && userregistrationtracking.data) {
      const { meta_fbc } = userregistrationtracking.data.trackings;

      if (meta_fbc && meta_fbc !== '' && meta_fbc !== undefined) {
        updateStorageTracking({ fbc: meta_fbc });
        return meta_fbc;
      }

      if (cookieFbc) {
        const result = await api.put('/userregistrationtracking', {
          meta_fbc: cookieFbc,
        });

        return result.data.trackings.meta_fbc;
      }

      if (storageTracking && storageTracking.fbc) {
        const result = await api.put('/userregistrationtracking', {
          meta_fbc: storageTracking.fbc,
        });

        return result.data.trackings.meta_fbc;
      }

      return userregistrationtracking.data.trackings.meta_fbc;
    }

    return cookieFbc;
  } catch (err) {
    console.log('Erro ao verificar fbc', err);
  }
}

export async function getFbp(userregistrationtracking) {
  try {
    const cookieFbp = Cookies.get('_fbp');
    const storageTracking = getStorageTracking();

    if (userregistrationtracking && userregistrationtracking.data) {
      const { meta_fbp } = userregistrationtracking.data.trackings;

      if (meta_fbp && meta_fbp !== '' && meta_fbp !== undefined) {
        updateStorageTracking({ fbp: meta_fbp });
        return meta_fbp;
      }

      if (cookieFbp) {
        const result = await api.put('/userregistrationtracking', {
          meta_fbp: cookieFbp,
        });

        return result.data.trackings.meta_fbp;
      }

      if (storageTracking && storageTracking.fbp) {
        const result = await api.put('/userregistrationtracking', {
          meta_fbp: storageTracking.fbp,
        });

        return result.data.trackings.meta_fbp;
      }

      return userregistrationtracking.data.trackings.meta_fbp;
    }

    return cookieFbp;
  } catch (err) {
    console.log('Erro ao verificar fbp', err);
  }
}

export async function ConversionApiMeta({
  eventId,
  eventName,
  email,
  phone,
  externalId,
  fbc,
  fbp,
}) {
  try {
    const data = {
      eventName,
    };

    if (fbc) {
      data.fbc = fbc;
    }

    if (fbp) {
      data.fbp = fbp;
    }

    if (eventId) {
      data.eventId = eventId;
    }

    if (externalId) {
      data.externalId = externalId;
    }

    if (email) {
      data.email = email;
    }

    if (phone) {
      data.phone = phone;
    }

    if (window.location.href) {
      data.eventSourceUrl = window.location.href;
    }

    try {
      // await axios.get('https://api.ipify.org/?format=json').then(response => {
      //   if (response.data && response.data.ip) {
      //     console.log('IPV4', response.data);
      //     data.clientIpAddress = response.data.ip;
      //   }
      // });

      await axios.get('https://api64.ipify.org/?format=json').then(response => {
        if (response.data && response.data.ip) {
          data.clientIpAddress = response.data.ip;
        }
      });
    } catch (err) {
      console.log(err);
    }

    const result = await axios.post(
      `${Connection.url_conversion_api}/meta/apiconversion`,
      data
    );

    // console.log('eventSucess', result);
    return result;
  } catch (err) {
    console.log('Erro ao enviar evento do Pixel', err);
  }
}
